<mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <h3 class="title">General</h3>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="d-flex">
        <mat-card class="report-card flex-grow-1">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">Tổng số</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center">
                    <p class="m-2">
                        {{generalReportData.total}}
                    </p>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="report-card flex-grow-1">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">Đã đồng ý</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center">
                    <div class="icon">
                        <mat-icon class="approved">check_circle</mat-icon>
                    </div>
                    <p class="m-2">
                        {{generalReportData.approved}}
                    </p>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="report-card flex-grow-1">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">Đã từ chối</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center">
                    <div class="icon">
                        <mat-icon class="rejected">cancel</mat-icon>
                    </div>
                    <p class="m-2">
                        {{generalReportData.rejected}}
                    </p>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="report-card flex-grow-1">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">SLA Trung bình</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center">
                    <div class="icon">
                        <mat-icon class="sla">schedule</mat-icon>
                    </div>
                    <p class="m-2">
                        {{generalReportData.sla}}%
                    </p>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="report-card flex-grow-1">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">Tỉ lệ quá hạn</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center">
                    <div class="icon">
                        <mat-icon class="timeout">group_work</mat-icon>
                    </div>
                    <p class="m-2">
                        {{generalReportData.timeout}}%
                    </p>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="report-card flex-grow-1">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">Xử lý nhiều nhất</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center">
                    <div class="avatar m-2">
                        <one-avatar size="32" [imageUrl]="highActivetUser.avatarUrl"></one-avatar>
                    </div>
                    <p class="m-2" style="padding-top: 4px;">
                        {{highActivetUser.fullName}}
                    </p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>


</mat-expansion-panel>
